import React, { Component } from 'react';
import $ from "jquery";
import PdfViewer from './PdfViewer';

class ReportItemsSoldsModal extends Component {

    componentDidMount() {
        this.closeAction();
    }

    closeAction = () => {
        const { cleanData } = this.props;
        $('#reportItemsSoldsModal').on('hidden.bs.modal', function () {
            cleanData();
        });
    };

    render() {

        const { ActualDate, ReportsModel, ChangeInitialDate,
            GetSoldItemsByDate, ChangeFinalDate, ChangeCashNotes,
            ChangeRefounds, MailTools,
            ShowPDFViewer, TypeDoc, ListReports, CleanReportModel, CloseReportItemsSoldsModal,
            sucursales, printhide, ShowFormatToPrint,
            ChangeSucursal,
        } = this.props
        return (
            <div className="modal fade" id="reportItemsSoldsModal" data-backdrop="static" data-keyboard="false" tabIndex="-1" aria-labelledby="reportItemsSoldsModalLabel" aria-hidden="true" >
                <div className="modal-dialog modal-lg modal-dialog-centered" >
                    <div className="modal-content">
                        <div className="modal-header" style={{ background: "#343a40" }}>
                            <h5 style={{ color: "white" }}>Artículos vendidos por fecha</h5>
                            <button
                                type="button"
                                className="close"
                                data-dismiss="modal"
                                aria-label="Close"
                                onClick={() => { CleanReportModel(); CloseReportItemsSoldsModal() }}

                                style={{ color: "white" }} >
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="mt-2 ml-3">

                                <div className='row'>

                                    <div className='col-12 col-md-5'>
                                        <div className="input-group mt-3">
                                            <div className="input-group-prepend">
                                                <span className="input-group-text"><strong>Desde: </strong></span>
                                            </div>
                                            <input
                                                type="date"
                                                className="form-control"
                                                max={ActualDate}
                                                value={ReportsModel && ReportsModel.InitialDate}
                                                onChange={(event) => ChangeInitialDate(event)}
                                                onKeyDown={(ev) => {
                                                    if (ev.key === 'Enter') {
                                                        GetSoldItemsByDate()

                                                    }
                                                }}


                                            />
                                        </div>
                                    </div>
                                    <div className='col-12 col-md-5'>
                                        <div className="input-group mt-3">
                                            <div className="input-group-prepend">
                                                <span className="input-group-text"><strong>Hasta: </strong></span>
                                            </div>
                                            <input
                                                type="date"
                                                className="form-control"
                                                max={ActualDate}
                                                value={ReportsModel && ReportsModel.FinalDate}
                                                onChange={(event) => ChangeFinalDate(event)}
                                                onKeyDown={(ev) => {
                                                    if (ev.key === 'Enter') {
                                                        GetSoldItemsByDate()

                                                    }
                                                }}


                                            />
                                        </div>
                                    </div>
                                    <div className='col-12 col-md-2'></div>
                                </div>
                                <div className='row'>
                                    <div className='col-12 col-md-8'>
                                        <div className="input-group mt-3">
                                            <div className='input-group-prepend'>
                                                <span className='input-group-text'><strong>Sucursal:</strong></span>
                                            </div>
                                            <select
                                                name="select"
                                                className="form-control"
                                                value={ReportsModel.Sucursal}
                                                onChange={event => ChangeSucursal(event)}
                                                style={{ color: "#000", borderRadius: 4, backgroundColor: "transparent", height: 40 }}
                                            >
                                                <option value="---">Selecciona</option>
                                                {!!sucursales && sucursales.map(sucursal => {
                                                    return (
                                                        <option value={sucursal.code}>{`${sucursal.nombre}`}</option>
                                                    )
                                                })}
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className='col-12 mt-3 font-weight-bold'> Tipos de operación: </div>
                                    <div className="col-12 col-lg-6">
                                        <div className="input-group mt-3">
                                            <div className="input-group-prepend">
                                                <div className="form-check input-group-text">
                                                    <input
                                                        type="checkbox"
                                                        id="checkCashNotes"
                                                        checked={ReportsModel.checkCashNotes}
                                                        onClick={ChangeCashNotes} />
                                                </div>
                                            </div>
                                            <label className="form-control" htmlFor="checkCashNotes"> Ventas </label>
                                        </div>
                                    </div>
                                    <div className="col-12 col-lg-6">
                                        <div className="input-group mt-3">
                                            <div className="input-group-prepend">
                                                <div className="form-check input-group-text">
                                                    <input
                                                        type="checkbox"
                                                        id="checkRefounds"
                                                        checked={ReportsModel.checkRefounds}
                                                        onClick={ChangeRefounds} />
                                                </div>
                                            </div>
                                            <label className="form-control" htmlFor="checkRefounds"> Devoluciones </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button
                                type="button"
                                className="btn btn-secondary"
                                onClick={() => { CleanReportModel(); CloseReportItemsSoldsModal() }}>Cancelar</button>
                            <button
                                type="button"
                                className="btn btn-primary"
                                onClick={() => GetSoldItemsByDate()}>
                                Generar</button>
                        </div>
                    </div>
                </div>
                <PdfViewer
                    DocsToPrint={ListReports}
                    TypeDoc={TypeDoc}
                    EnableEditButton={false}
                    Editable={false}
                    ChangeEditableMode={false}
                    EditableDocModel={'SalesTools.EditableDocModel'}
                    RefreshDocModel={'SalesTools.RefreshDocModel'}
                    SaveChanges={'SalesTools.SaveChangesOrderInvoice'}
                    UploadDoc={'SalesTools.UploadInvoice'}
                    EditParam1={false}
                    ShowPDFViewer={() => { ShowPDFViewer(); CleanReportModel(); }}
                    user={'user'}
                    Counter={true}
                    ReportsModel={ReportsModel}
                    MailTools={MailTools}
                    printhide={printhide}
                    ShowFormatToPrint={ShowFormatToPrint}
                    reprint={false}
                />

            </div>
        );
    }
}

export default ReportItemsSoldsModal;